import { Button } from '@heroui/react'
import { useQueryClient } from '@tanstack/react-query'
import { useRouter } from '@tanstack/react-router'
import { CenteredLayout } from '#widgets/layouts/centered-layout'
import styles from './something-went-wrong.module.scss'

interface SomethingWentWrongProps {
  children?: React.ReactNode
  withHardReload?: boolean
}

export default function SomethingWentWrong({
  children = 'Ой! Что-то пошло не так.',
  withHardReload,
}: SomethingWentWrongProps) {
  const router = useRouter()
  const queryClient = useQueryClient()

  const onReload = () => {
    if (withHardReload) {
      queryClient.clear()
      window.location.reload()
    } else {
      router.invalidate({
        filter: route => route.pathname === window.location.pathname,
      })
    }
  }

  return (
    <CenteredLayout>
      <div className={styles.root}>
        <div className={styles.text}>{children}</div>
        <Button color="primary" size="lg" onClick={onReload}>
          Перезагрузить
        </Button>
      </div>
    </CenteredLayout>
  )
}
